import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AppEntryRepository = {
  create: (request) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/appEntries`,
      method: "POST",
      data: request,
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  getById: (id) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/appEntries/${id}`,
      method: "GET",
    });
  },

  getAll: (page, size, filterParams, orderBy, orderDirection) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/appEntries/all`,
      method: "POST",
      params: {
        page: page,
        size: size,
        sort: `${orderBy},${orderDirection}`,
      },
      data: filterParams,
    });
  },

  checkStatus: (trackingNumber, email) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/appEntries/check/status`,
      method: "POST",
      data: {
        trackingNumber: trackingNumber,
        email: email,
      },
      withCredentials: true,
    });
  },

  uploadCorrectionFiles: (request) => {
    return axios({
      url: `${SETTINGS.EXTERNAL_API_URL}external/appEntries/uploadCorrectionFiles`,
      method: "POST",
      data: request,
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
